// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Cookies from 'js-cookie';
import { getAdminModule } from '@/utils/settingMer';
var TokenKeys = {
  platform: 'Java-platformToken',
  business: 'businessToken',
  region: 'regionToken'
};
function getTokenKey() {
  return TokenKeys[getAdminModule()] || TokenKeys.platform;
}
export function getToken() {
  return Cookies.get(getTokenKey());
}
export function setToken(token) {
  return Cookies.set(getTokenKey(), token);
}
export function removeToken() {
  return Cookies.remove(getTokenKey());
}